// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__3ME4O","logoImg":"Logo_logoImg__1Sfil","logoDiv":"Logo_logoDiv__kn60U","title":"Logo_title__1eRM-"};